export { default } from './DescriptionTooltip';
